export default __webpack_public_path__ + "static/media/bnb.70a22868.svg";